/**
 * @generated SignedSource<<5a0b9a0cc32c21edbe91206f38c2b71e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ListItemTeamIndicator_team$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AHTeamIconCircle">;
  readonly " $fragmentType": "ListItemTeamIndicator_team";
};
export type ListItemTeamIndicator_team$key = {
  readonly " $data"?: ListItemTeamIndicator_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"ListItemTeamIndicator_team">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ListItemTeamIndicator_team",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AHTeamIconCircle"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "6e90ca59225fc515695eacab4ab9d0ca";

export default node;
